import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Message } from '../../models/message.model';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';


@Component({
    selector: 'app-message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatInputModule, MatDialogModule, MatIconModule]
})
export class MessageDialogComponent implements OnInit{

  disabled = false;

  loginMessage = "";
  signupMode = false;
  submitText = this.signupMode ? "Signup":"Login";

  message: Message = new Message();
  
  constructor(
    public dialogRef: MatDialogRef<MessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Message,
    private store: Store,
    private router: Router, 
    private route: ActivatedRoute) {

    }

    ngOnInit(): void {
  
    } 
  
    onNoClick(): void {
      this.dialogRef.close();
    }
}
